<template>
	<div class="Echartbox" >
		<div id="dataEchart" ></div>
	</div>
</template>

<script>
	export default {
		name: "dataEchart",
		props: {
			dataobj: {
				type: Object,
				default: ()=>{
					return {}
				},
			},
		},
		data() {
			return {
				myChart1: null,
				option: {
					color: ['rgba(255, 89, 43, 1)', 'rgba(43, 117, 235, 1)', 'rgba(88, 226, 204, 1)', 'rgba(249, 204, 68, 1)'],
					tooltip: {
						trigger: 'axis',
						// 提示框浮层的文本样式。
						backgroundColor: 'rgb(255, 255, 255)',
						extraCssText: 'box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;',
						textStyle: {
							color: '#363636'
						},
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '10%',
						containLabel: true
					},
					xAxis: {

						type: 'category',
						axisLine: {
							lineStyle: {
								color: 'rgb(222,222,222)',
								width: 2
							}
						},
						axisLabel: {
							color: 'rgb(51,51,51)'
						},
						axisTick: {
							lineStyle: {
								color: 'rgb(222,222,222)'
							},
							alignWithLabel: true
						},
						boundaryGap: false,
						data: [],
					},
					yAxis: {
					
						axisLine: {
							show: false,
						},
						axisTick: {
							// show: false,
							lineStyle: {
								color: 'rgb(222,222,222,0)'
							},
							alignWithLabel: true
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(243, 243, 243, 1)'
							},
							
						},
						type: 'value'
					}, 
					series: [
						{
							showSymbol: false,
							name: '分享内容数量', 
							type: 'line',
							smooth: true,
							data: []
						},
						{
							name: '浏览次数数量',
							type: 'line',
							smooth: true,
							data: []
						},
						{
							name: '新增线索数量',
							type: 'line',
							smooth: true,
							data: []
						},
						{
							name: '意向客户数量',
							type: 'line',
							smooth: true,
							data: []
						},
					]
				},
			}
		},
		watch: {
			dataobj(){
				this.fn_SetDatas()
			},
		},
		methods: {
			fn_SetDatas(){
				if(this.dataobj) {
					let len = this.option.series.length
					for(let i = 0; i < len;i++) {
						if(i == 0) { // 分享内容数量
							this.option.series[i].data = this.dataobj.share_content ? this.dataobj.share_content : [];
						}
						else if(i == 1) {  // 浏览次数数量
							this.option.series[i].data = this.dataobj.visit ? this.dataobj.visit : [];
						}
						else if(i == 2) {  // 新增线索数量
							this.option.series[i].data = this.dataobj.cuepool ? this.dataobj.cuepool : [];
						}
						else if(i == 3) {  // 意向客户数量
							this.option.series[i].data = this.dataobj.customer ? this.dataobj.customer : [];
						}
					}
					this.option.xAxis.data = this.dataobj.day || []
					this.drawLine()
				}
			},
			drawLine() {
				// 基于准备好的dom，初始化echarts实例
				let myChart1 = this.$echarts.init(document.getElementById('dataEchart'))
				// 绘制图表
				myChart1.setOption(this.option);
				this.myChart1 = myChart1;
			},
		},
	}
</script>

<style scoped lang="scss">
	.Echartbox {
		width: 100%;
		background-color: #fff;
		margin-bottom: 10px;
		position: absolute;
		height: 100%;
		#dataEchart{
			width: 100%;
			height: 100%;
		}
	}
</style>
